import { AxiosError } from "axios";

export const rejectCatchError = (
    error: unknown,
    rejectWithValue: any
) => {
    if (error instanceof AxiosError && error.response) {
        return rejectWithValue(error.response.data.message || 'Произошла ошибка');
    } else if (error instanceof Error) {
        return rejectWithValue(error.message);
    } else {
        return rejectWithValue('Произошла неизвестная ошибка');
    }
};